import { useQuery } from "@tanstack/react-query";

import type { GetEmployeeMeetingStatsSearchServiceJsonResponse } from "@performyard/service-contracts";

import { employeeMeetingStatsSearchQuery } from "../../../api/queries";
import type { GetEmployeeMeetingStatsParams } from "../../../api/services/defs/internal-api";

import type { PYUseQueryOptions } from "../StandardQueryArguments";

export const useEmployeeMeetingStatsSearch = (
	params: GetEmployeeMeetingStatsParams,
	options?: PYUseQueryOptions<GetEmployeeMeetingStatsSearchServiceJsonResponse>
) => {
	const query = useQuery<GetEmployeeMeetingStatsSearchServiceJsonResponse>({
		...employeeMeetingStatsSearchQuery(params),
		...options,
	});

	return {
		data: query?.data?.results ?? [],
		totalCount: query?.data?.total ?? 0,
		isLoading: query?.isLoading,
		isFetching: query?.isFetching,
	};
};
